// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.controlPanel-btnBox{
    margin: auto;
    display: flex;
    justify-content: center;
}
.controlPanel-btnBox button, .controlPanel-btnBox a{
    border: 0;
    padding: .5em;
    background: rgba(250, 250, 250, .8);
    box-shadow: 0 0 2px 2px rgba(200,200,200);
    width: 90%;
    font-weight: bold;
    color: rgba(20, 20, 20, .8);
    outline: none;
    text-shadow: 2px 2px rgba(100,100,100,.1);
    border-radius: 8px;
    text-align: center;
    text-decoration: none;
    /* border-bottom-left-radius: 0;
    border-bottom-right-radius: 0; */
}
.controlPanel-btnBox svg {
    margin-right: .3em;
}
.controlPanel-btnBox.red button, .controlPanel-btnBox.red a{
    background: rgba(250, 0, 0, .8);
    box-shadow: 0 0 2px 2px rgba(255,0,0);
}
.controlPanel-btnBox.blue button, .controlPanel-btnBox.blue a{
    background: rgb(0, 132, 213);
    box-shadow: 0 0 2px 2px rgb(0, 102, 183);
    color: white;
}
.controlPanel-btnBox.orange button, .controlPanel-btnBox.orange a{
    background: rgb(235, 119, 10);
    box-shadow: 0 0 2px 2px rgb(205, 89, 0);
    color: white;
}
.controlPanel-btnBox.section button, .controlPanel-btnBox.section a{
    /* border-top-left-radius: 0;
    border-top-right-radius: 0;
    border-bottom-left-radius: 8px;
    border-bottom-right-radius: 8px; */
}
.controlPanel-btnBox#logout{
    margin-top: 2.5em;
}
.controlPanel-btnBox#logout button{
    border-radius: 8px;
}
.controlPanel-btnBox{
    margin-top: 1.8em;
}

.dashboard-box{
    box-shadow: 0 0 2px 2px rgb(0, 132, 213);
    display:flex;
    width: 9em;
    height: 8em;
    justify-content: space-around;
    align-items: center;
    flex-direction: column;
    background: rgb(0, 132, 213);
    color:white;
}
a.dashboard-box{
    color:white;
    text-decoration: none;
}
.dashboard-box h1, .dashboard-box label{
    margin:0;
    font-weight: bold
}
.dashboard-box:nth-child(1){
    border-top-left-radius: 10px;
    box-shadow: 0 0 2px 2px rgb(0, 65, 0);
    background:rgb(0, 165, 47);
}
.dashboard-box:nth-child(2){
    border-top-right-radius: 10px;
    box-shadow: 0 0 2px 2px rgb(0, 90, 90);
    background:rgb(0, 190, 190);
}
.dashboard-box:nth-child(3){
    border-bottom-left-radius: 10px;
    box-shadow: 0 0 2px 2px rgb(56, 0, 48);
    background:rgb(156, 0, 148);
}
.dashboard-box:nth-child(4){
    border-bottom-right-radius: 10px;
    box-shadow: 0 0 2px 2px rgb(0, 0, 120);
    background:rgb(100, 26, 220);
}
.dashbox-container{
    display:grid;
    grid-template-columns: auto auto;
    justify-content: center;
    margin-top: 2em;
    column-gap: 1em;
    row-gap: 1em;
}

#controlPanel{
    padding-bottom: 5em;
}`, "",{"version":3,"sources":["webpack://./css/control_panel.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,SAAS;IACT,aAAa;IACb,mCAAmC;IACnC,yCAAyC;IACzC,UAAU;IACV,iBAAiB;IACjB,2BAA2B;IAC3B,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,kBAAkB;IAClB,qBAAqB;IACrB;oCACgC;AACpC;AACA;IACI,kBAAkB;AACtB;AACA;IACI,+BAA+B;IAC/B,qCAAqC;AACzC;AACA;IACI,4BAA4B;IAC5B,wCAAwC;IACxC,YAAY;AAChB;AACA;IACI,6BAA6B;IAC7B,uCAAuC;IACvC,YAAY;AAChB;AACA;IACI;;;sCAGkC;AACtC;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;AACtB;AACA;IACI,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,YAAY;IACZ,UAAU;IACV,WAAW;IACX,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW;AACf;AACA;IACI,WAAW;IACX,qBAAqB;AACzB;AACA;IACI,QAAQ;IACR;AACJ;AACA;IACI,4BAA4B;IAC5B,qCAAqC;IACrC,0BAA0B;AAC9B;AACA;IACI,6BAA6B;IAC7B,sCAAsC;IACtC,2BAA2B;AAC/B;AACA;IACI,+BAA+B;IAC/B,sCAAsC;IACtC,2BAA2B;AAC/B;AACA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,4BAA4B;AAChC;AACA;IACI,YAAY;IACZ,gCAAgC;IAChC,uBAAuB;IACvB,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".controlPanel-btnBox{\n    margin: auto;\n    display: flex;\n    justify-content: center;\n}\n.controlPanel-btnBox button, .controlPanel-btnBox a{\n    border: 0;\n    padding: .5em;\n    background: rgba(250, 250, 250, .8);\n    box-shadow: 0 0 2px 2px rgba(200,200,200);\n    width: 90%;\n    font-weight: bold;\n    color: rgba(20, 20, 20, .8);\n    outline: none;\n    text-shadow: 2px 2px rgba(100,100,100,.1);\n    border-radius: 8px;\n    text-align: center;\n    text-decoration: none;\n    /* border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0; */\n}\n.controlPanel-btnBox svg {\n    margin-right: .3em;\n}\n.controlPanel-btnBox.red button, .controlPanel-btnBox.red a{\n    background: rgba(250, 0, 0, .8);\n    box-shadow: 0 0 2px 2px rgba(255,0,0);\n}\n.controlPanel-btnBox.blue button, .controlPanel-btnBox.blue a{\n    background: rgb(0, 132, 213);\n    box-shadow: 0 0 2px 2px rgb(0, 102, 183);\n    color: white;\n}\n.controlPanel-btnBox.orange button, .controlPanel-btnBox.orange a{\n    background: rgb(235, 119, 10);\n    box-shadow: 0 0 2px 2px rgb(205, 89, 0);\n    color: white;\n}\n.controlPanel-btnBox.section button, .controlPanel-btnBox.section a{\n    /* border-top-left-radius: 0;\n    border-top-right-radius: 0;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px; */\n}\n.controlPanel-btnBox#logout{\n    margin-top: 2.5em;\n}\n.controlPanel-btnBox#logout button{\n    border-radius: 8px;\n}\n.controlPanel-btnBox{\n    margin-top: 1.8em;\n}\n\n.dashboard-box{\n    box-shadow: 0 0 2px 2px rgb(0, 132, 213);\n    display:flex;\n    width: 9em;\n    height: 8em;\n    justify-content: space-around;\n    align-items: center;\n    flex-direction: column;\n    background: rgb(0, 132, 213);\n    color:white;\n}\na.dashboard-box{\n    color:white;\n    text-decoration: none;\n}\n.dashboard-box h1, .dashboard-box label{\n    margin:0;\n    font-weight: bold\n}\n.dashboard-box:nth-child(1){\n    border-top-left-radius: 10px;\n    box-shadow: 0 0 2px 2px rgb(0, 65, 0);\n    background:rgb(0, 165, 47);\n}\n.dashboard-box:nth-child(2){\n    border-top-right-radius: 10px;\n    box-shadow: 0 0 2px 2px rgb(0, 90, 90);\n    background:rgb(0, 190, 190);\n}\n.dashboard-box:nth-child(3){\n    border-bottom-left-radius: 10px;\n    box-shadow: 0 0 2px 2px rgb(56, 0, 48);\n    background:rgb(156, 0, 148);\n}\n.dashboard-box:nth-child(4){\n    border-bottom-right-radius: 10px;\n    box-shadow: 0 0 2px 2px rgb(0, 0, 120);\n    background:rgb(100, 26, 220);\n}\n.dashbox-container{\n    display:grid;\n    grid-template-columns: auto auto;\n    justify-content: center;\n    margin-top: 2em;\n    column-gap: 1em;\n    row-gap: 1em;\n}\n\n#controlPanel{\n    padding-bottom: 5em;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
